import { ThemeEnum } from "@src/app/hooks/useTheme";
import type { BFFArticleBodyElement, BFFArticleCard } from "@src/app/types/bff";

import CategoryTag from "../../CategoryTag";
import Link from "../../Link";

export default function ArticleRelation({
  element,
  relationArticles = [],
}: {
  element: BFFArticleBodyElement["relation"];
  /** relation articles in Relation Element */
  relationArticles: BFFArticleCard[];
}) {
  const article = relationArticles.find((i) => i.id === element.id);

  if (!article) return null;

  return (
    <Link
      to={`${article.urlPath || ""}?ref=article-in-depth-reading`}
      id={`article-relation-${article.id}`}
    >
      <div className="group bg-background-secondary text-primary dark:bg-background-secondary-on-dark dark:text-primary-on-dark my-4 flex justify-between gap-3 px-3 py-4">
        <div>
          <CategoryTag theme={ThemeEnum.light} name="Further Reading" />
          <h4 className="text-header-4 group-hover:text-link-hover mt-2 line-clamp-3 transition-all duration-200">
            {article.title || ""}
          </h4>
        </div>
        <div className="w-30 flex-none overflow-hidden">
          <img
            className="h-auto w-full object-cover transition-transform duration-300 lg:group-hover:scale-105"
            src={article.cover || ""}
            alt=""
          />
        </div>
      </div>
    </Link>
  );
}
